import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Flex, Modal, Typography } from 'antd';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { getEnv } from '../../helpers/mobx-easy-wrapper';
import { YouTubeAuthModal } from './youtube/youtube-auth';
import TikTokAuth from './tiktok/tiktok-auth';
import InstagramAuth from './instagram/instagram-auth';
import FacebookAuth from './facebook/facebook-auth';
import { useTranslation } from 'react-i18next';

export interface SocialAccountsModalRef {
  open: () => void;
  close: () => void;
}

export interface SocialAccountsModalProps {
  onAccountAdded: () => void;
}

export const SocialAccountsModal = forwardRef<
  SocialAccountsModalRef,
  SocialAccountsModalProps
>(({ onAccountAdded }, ref) => {
  const { t } = useTranslation();
  const {
    envConfig: { youtube_client_id },
  } = getEnv();

  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  useImperativeHandle(ref, () => ({
    open: openModal,
    close: closeModal,
  }));

  return (
    <Modal
      maskClosable={false}
      onCancel={closeModal}
      footer={null}
      title={t('socialAccounts.addAccount')}
      open={isOpen}
    >
      <Flex gap={15} style={{ flexDirection: 'column' }}>
        <div>
          <GoogleOAuthProvider clientId={youtube_client_id}>
            <YouTubeAuthModal onAccountAdded={onAccountAdded} />
          </GoogleOAuthProvider>
        </div>
        <div className="tiktok">
          <TikTokAuth onAccountAdded={onAccountAdded} />
        </div>
        <div className="instagram">
          <InstagramAuth onAccountAdded={onAccountAdded} />
        </div>
        <div className="facebook">
          <FacebookAuth onAccountAdded={onAccountAdded} />
        </div>
        <div>
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            {t('socialAccounts.helpText')}
          </Typography.Text>
        </div>
      </Flex>
    </Modal>
  );
});
